export default __webpack_public_path__ + "static/media/image.21b8d204.svg";